/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner } from './get-onboarding-request-by-id200-response-identity-verification-inner-records-inner';

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseIdentityVerificationInner
 */
export interface GetOnboardingRequestById200ResponseIdentityVerificationInner {
    /**
     * 
     * @type {Array<GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner>}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'records'?: Array<GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'methodType'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'relatedIdentityVerificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'verificationSourceType'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'verificationReferenceURLs'?: Array<string>;
}

export const GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum = {
    idDocument: 'ID_DOCUMENT',
    idDocumentWa: 'ID_DOCUMENT_WA',
    idDocumentI: 'ID_DOCUMENT_I',
    companyVerificationDocument: 'COMPANY_VERIFICATION_DOCUMENT',
    supplementalDocument: 'SUPPLEMENTAL_DOCUMENT'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum];
export const GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum = {
    trustdock: 'TRUSTDOCK',
    pocketSign: 'POCKET_SIGN',
    internal: 'INTERNAL'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum];


